// extracted by mini-css-extract-plugin
export default {"AdminTitle":"styles_AdminTitle__u6X89","title3":"styles_title3__fAiAr","title4":"styles_title4__nLzmi","title5":"styles_title5__PxlEP"};